module.exports = __webpack_public_path__ + "static/img/4.50e6bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/4.png
// module id = 4fuz
// module chunks = 1